(() => {
  // Every pro-network section loads this file; only the first copy runs.
  if (window.proNetworkReveal) return;
  window.proNetworkReveal = true;

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const selector = '[data-pn-reveal], [data-pn-stagger]';
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  const observe = (root) => root.querySelectorAll(selector).forEach((el) => observer.observe(el));

  document.documentElement.classList.add('pn-motion');
  observe(document);
  // The theme editor re-renders sections in place; observe the fresh markup.
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();
